import React from 'react';
import '../styles/PageTitle.css';

const PageTitle = () => {
  return (
    <div className="page-title-container">
      <h1 className="page-title">
        <span className="schedule-text">配信スケジュール</span>
      </h1>
    </div>
  );
};

export default PageTitle;
